module.exports = __webpack_public_path__ + "static/pill-fuchsia-8a4ab0d041adb429dda5a98f16ea01f7.svg";